import { render } from "./AutoInvestment.vue?vue&type=template&id=2e71f9ee&scoped=true"
import script from "./AutoInvestment.vue?vue&type=script&lang=js"
export * from "./AutoInvestment.vue?vue&type=script&lang=js"

import "./AutoInvestment.vue?vue&type=style&index=0&id=2e71f9ee&lang=css&scoped=true"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e71f9ee"]])

export default __exports__